import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getDatabase } from "firebase/database";
// import { FIREBASE_DEV_URL, FIREBASE_STAGING_URL, FIREBASE_PROD_URL } from "./constants";

const getdburl = () => {
  const url = process.env.REACT_APP_FIREBASE_URL;
  if (!url) {
    console.warn("REACT_APP_FIREBASE_URL environment variable is not set. Using default Firebase URL.");
    return "https://brigiz-default-rtdb.firebaseio.com/";
  }
  return url;
};

const firebaseConfig = {
  apiKey: "AIzaSyDB7RpdNZqMxOxN__Q7tIYh7FFyu1-8Lkk",
  authDomain: "brigiz.firebaseapp.com",
  databaseURL: getdburl(),
  projectId: "brigiz",
  storageBucket: "brigiz.appspot.com",
  messagingSenderId: "974682362227",
  appId: "1:974682362227:web:1fedd37216efc64b70b506",
  measurementId: "G-1961WVS28D"
};

let app, db, database, auth, storage;

try {
  app = initializeApp(firebaseConfig);
  db = getFirestore(app);
  database = getDatabase(app);
  auth = getAuth(app);
  storage = getStorage(app);
} catch (error) {
  console.error("Error initializing Firebase:", error);
  // Provide fallback or re-throw based on your error handling strategy
  throw new Error("Failed to initialize Firebase. Please check your configuration.");
}

export { db, auth, storage, database };